import WhatsAppIcon from "../ui/WhatsAppIcon";
import {
  ABN,
  DARK_BG,
  DARK_BORDER,
  NAV_LINKS,
  WA_LINK,
  type NavigateFn,
} from "../../lib/site";
import { trackCtaClick } from "../../utils/analytics";
import { LogoWordmark } from "./Logo";

export default function Footer({ navigate }: { navigate: NavigateFn }) {
  return (
    <footer
      className="pt-16 pb-8"
      style={{ backgroundColor: DARK_BG, borderTop: `1px solid ${DARK_BORDER}` }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid sm:grid-cols-4 gap-10 mb-14">
          <div className="sm:col-span-2">
            <LogoWordmark light />
            <p
              className="text-sm mt-5 mb-5 max-w-xs leading-relaxed"
              style={{ color: "rgba(246,243,238,0.50)" }}
            >
              Websites, Maps, and enquiry systems for local businesses that live
              on phone calls. More calls. Stronger suburb visibility. Faster enquiries.
            </p>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackCtaClick("footer_whatsapp", WA_LINK)}
              className="inline-flex items-center gap-2 text-sm transition-colors hover:text-[#FF5500]"
              style={{ color: "rgba(246,243,238,0.55)" }}
            >
              <WhatsAppIcon size={15} className="text-[#25D366]" />
              WhatsApp
            </a>
          </div>
          <div>
            <div
              className="text-[10px] font-bold tracking-[0.2em] uppercase mb-5"
              style={{ color: "rgba(246,243,238,0.35)" }}
            >
              Navigation
            </div>
            <div className="space-y-3">
              {NAV_LINKS.map((l) => (
                <button
                  type="button"
                  key={l.page}
                  onClick={() => navigate(l.path)}
                  className="block text-sm transition-colors hover:text-[#F6F3EE]"
                  style={{ color: "rgba(246,243,238,0.45)" }}
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div
              className="text-[10px] font-bold tracking-[0.2em] uppercase mb-5"
              style={{ color: "rgba(246,243,238,0.35)" }}
            >
              Legal
            </div>
            <div className="space-y-2 text-sm" style={{ color: "rgba(246,243,238,0.40)" }}>
              <div className="font-medium" style={{ color: "rgba(246,243,238,0.60)" }}>
                ONIN PTY LTD
              </div>
              <div className="text-xs">{ABN}</div>
              <div className="text-xs">Australia</div>
            </div>
          </div>
        </div>
        <div
          className="pt-6 flex flex-wrap items-center justify-between gap-3"
          style={{ borderTop: `1px solid rgba(255,255,255,0.06)` }}
        >
          <div className="text-xs" style={{ color: "rgba(246,243,238,0.30)" }}>
            © {new Date().getFullYear()} ONIN PTY LTD. All rights reserved.
          </div>
          <div className="text-xs" style={{ color: "rgba(246,243,238,0.30)" }}>
            {ABN}
          </div>
        </div>
      </div>
    </footer>
  );
}
